import React, { type ErrorInfo, type ReactNode } from 'react'

import { logEvent } from '../../services/datadog'

type Props = {
  children: ReactNode
  fallback?: ReactNode
}

type State = { hasError: boolean; error: Error | null }

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    logEvent('error_boundary_caught', undefined, { componentStack: errorInfo.componentStack }, error, 'error')
  }

  render(): ReactNode {
    if (this.state.hasError && this.state.error) {
      return this.props.fallback ?? null
    }
    return this.props.children
  }
}
